// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { BundleResponse, bundleResponseSchema } from '@/bundle/api/types';

/**
 * Fetches a single bundle's details from the API, including its members.
 */
export async function getBundle(key: string): Promise<BundleResponse> {
  const url = `/v1/catalog/bundle/${key}`;
  const response = await api.get(url);
  return parseResponse(bundleResponseSchema, response.data, {
    schemaName: 'Bundle',
    endpoint: url,
  });
}
